import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { QrCard } from "@/components/QrCard";

export default function PayPage() {
  const { username } = useParams();
  const [m, setM] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api.get(`/public/pay/${username}`).then((r) => setM(r.data)).catch((e) => setErr(errMsg(e)));
  }, [username]);

  return (
    <div className="min-h-screen bg-[#0A1F44] grid-bg" data-testid="pay-page">
      <div className="mx-auto flex max-w-lg flex-col items-center px-5 py-10">
        <Brand dark />
        <div className="rise mt-8 w-full">
          {err && <div data-testid="pay-error" className="rounded-xl bg-white p-8 text-center text-slate-600">{err}</div>}
          {!m && !err && <div className="text-center text-slate-300">Loading...</div>}
          {m && <QrCard name={m.business_name} upi={m.upi_id} qr={m.qr_url} />}
        </div>
        <div className="mt-6 flex items-center gap-2 text-xs text-slate-400"><ShieldCheck className="h-4 w-4 text-emerald-400" /> Secured by YesPayBizz</div>
      </div>
    </div>
  );
}
